export default __webpack_public_path__ + "static/media/el_3.d8683ba9.mp3";